import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../Globals/constants';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import { semanticColors } from '../../Globals/styles';


class weekdayWorkplaceDrop extends Component {
  render() {
    const { connectDropTarget, isOver, canDrop} = this.props;

    let isOverAndCanDrop = canDrop && isOver;

    return(
      <div>
        {connectDropTarget(
          <div style={[styles.dropTarget, isOverAndCanDrop && styles.isOver]}></div>
        )}
      </div>
    )
  }
}


var styles = {
  dropTarget: {
    top: '0',
    left: '0',
    bottom: '0',
    position: 'absolute',
    width: '100%',
    borderRadius:'2px'
  },
  isOver: {
    backgroundColor: semanticColors.default,
    opacity: '0.5',
    zIndex: '1000',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: semanticColors.info,
    clear: 'both'
  }
}

const SorterEmployeeTarget = {
  drop(props, monitor) {
    if(monitor.getItem().isStickyNote)
      props.onStickynoteDrop()
    else
      props.onWorkplaceDrop(monitor.getItem().workplace)
  },
  canDrop(props, monitor){
    if(monitor.getItem().isStickyNote)
      return true
    return !props.isWorkplaceDropped(monitor.getItem().workplace.id);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
}
  weekdayWorkplaceDrop.propTypes = {
    onWorkplaceDrop: PropTypes.func.isRequired,
    isWorkplaceDropped: PropTypes.func.isRequired,
    isCompressed: PropTypes.bool.isRequired,
    onStickynoteDrop: PropTypes.func.isRequired
  };
export default DropTarget([dragNDropConstants.WORKPLACE, dragNDropConstants.STICKYNOTE], SorterEmployeeTarget, collect)(Radium(weekdayWorkplaceDrop));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/weekdayWorkplaceDrop.jsx